---
ID: 66d810b889048aba1b50e5ea
---

<script>
    import Loader from "$lib/components/elements/Loader.svelte"

    const blocks = [
  {
    "id": "EhPRGSNXR1",
    "type": "text",
    "html": "<p>Callout boxes are a powerful way to highlight important information in your documentation, helping to draw attention to specific messages or alerts. EasyPageGO offers five different variants of callout boxes:&nbsp;<b>Note</b>,&nbsp;<b>Info</b>,&nbsp;<b>Success</b>,&nbsp;<b>Warning</b>, and&nbsp;<b>Error</b>. Each variant serves a distinct purpose and can enhance the clarity of your content.</p><p>The body of the callout boxes is formatable, allowing you to use all the text formatting features listed in the&nbsp;<u><a href=\"https://docs.easypagego.com/editor/text-formatting/\" target=\"_blank\" rel=\"noopener noreferrer\">Text Formatting</a></u>&nbsp;page.</p><p>By using these callout boxes appropriately, you can effectively guide your users through your documentation, ensuring they understand critical information and potential pitfalls.</p><h2 id=\"variants-of-callout-boxes\"><b>Variants of Callout Boxes</b></h2><p>There are five different variants.&nbsp;There are 5 variations available. It is possible to change the variant of a callout box through its menu.</p><h3 id=\"note\">Note</h3><p>Use the&nbsp;<b>Note</b>&nbsp;variant to provide additional context or supplementary information that enhances understanding but is not critical to the main content.</p>"
  },
  {
    "id": "V1ngj-4jbd",
    "type": "callout",
    "variant": "note",
    "html": "<p><b>Example</b>:&nbsp;<i>This feature is currently in beta and may be subject to change.</i></p>"
  },
  {
    "id": "SVd1WfGuJs",
    "type": "text",
    "html": "<h3 id=\"info\">Info</h3><p>The&nbsp;<b>Info</b>&nbsp;box is ideal for conveying general information that your users should be aware of during their experience.</p>"
  },
  {
    "id": "Y1dJPSBOtQ",
    "type": "callout",
    "variant": "info",
    "html": "<p><b>Example</b>:&nbsp;<i>Our documentation is regularly updated to reflect the latest changes.</i></p>"
  },
  {
    "id": "2sIA34gVVT",
    "type": "text",
    "html": "<h3 id=\"success\">Success</h3><p>Highlight successful actions or positive outcomes with the&nbsp;<b>Success</b>&nbsp;variant. This is perfect for acknowledging user achievements or signaling completion.</p>"
  },
  {
    "id": "gZ99xKpD-F",
    "type": "callout",
    "variant": "success",
    "html": "<p><b>Example</b>:&nbsp;<i>Hooray! You successfully completed our SDK setup!</i></p>"
  },
  {
    "id": "_o3oEfyYOm",
    "type": "text",
    "html": "<h3 id=\"warning\">Warning</h3><p>The&nbsp;<b>Warning</b>&nbsp;box is used to alert users to potential issues or important considerations that could impact their progress.</p>"
  },
  {
    "id": "bReXgowZHS",
    "type": "callout",
    "variant": "warning",
    "html": "<p><b>Example</b>:&nbsp;<i>Ensure that you back up your data before proceeding with the update.</i></p>"
  },
  {
    "id": "DfNlEYeLZ7",
    "type": "text",
    "html": "<h3 id=\"error\">Error</h3><p>When immediate attention is needed due to a critical issue, use the&nbsp;<b>Error</b>&nbsp;variant to communicate errors or problems effectively.</p>"
  },
  {
    "id": "7zLuJyCfxc",
    "type": "callout",
    "variant": "error",
    "html": "<p><b>Example</b>:&nbsp;<i>If you don't see the expected output, you may have to start over.</i></p>"
  }
];
</script>

{#each blocks as block}
<Loader {block}/>
{/each}